export default __webpack_public_path__ + "static/media/35-BeachTui.a6843aec.jpeg";